/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { Image, FileText, Paperclip } from 'lucide-react';
import "./style.css";

export const CmpUserbubble = ({ text, className, reactions, attachments }) => {
  return (
    <div className={`cmp-userbubble ${className}`}>
      {/* 🎯 EMOJI POSITIONED OUTSIDE OVERLAP: Free from container constraints */}
      {reactions && reactions.length > 0 && (
        <div className="emoji-overlay-absolute">
          <div className="emoji-reactions">
            {reactions.map((reaction, index) => (
              <div key={index} className="emoji-reaction-badge">
                {typeof reaction === 'string' ? reaction : reaction.emoji}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* 🎯 ATTACHMENTS: Render file thumbnails/previews */}
      {attachments && attachments.length > 0 && (
        <div className="user-bubble-attachments">
          {attachments.map((attachment) => (
            <div key={attachment.id} className="user-bubble-attachment">
              {attachment.type === 'image' ? (
                <>
                  <img 
                    src={attachment.preview || attachment.url} 
                    alt={attachment.filename}
                    className="attachment-image"
                    style={{ width: '20px', height: '20px', borderRadius: '4px', objectFit: 'cover' }}
                  />
                  <span className="attachment-name">{attachment.filename}</span>
                  <span className="attachment-size">
                    {Math.round(attachment.size_bytes / 1024)}KB
                  </span>
                </>
              ) : (
                <>
                  <FileText className="attachment-icon" size={12} />
                  <span className="attachment-name">{attachment.filename}</span>
                  <span className="attachment-size">
                    {Math.round(attachment.size_bytes / 1024)}KB
                  </span>
                </>
              )}
            </div>
          ))}
        </div>
      )}
      
      <div className="overlap">
        <div className="rectangle" />
        <div className="text-wrapper-7">{text}</div>
      </div>
    </div>
  );
};
